import { render, staticRenderFns } from "./app-button.vue?vue&type=template&id=1de3eb78&scoped=true&"
var script = {}
import style0 from "./app-button.vue?vue&type=style&index=0&id=1de3eb78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de3eb78",
  null
  
)

export default component.exports